import ROHistoryCard from 'src/components/ROHistoryCard/ROHistoryCard';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    roHistory: state.ROHistory.allRoHistory.roHistory,
    custMode: state.Framework.custMode,
    theme: state.Framework.theme,
    locale: state.Framework.locale,
});

export default connect(mapStateToProps)(ROHistoryCard);